import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

/* Date picker that displays dd-mm-yyyy but stores yyyy-mm-dd (so backend
   payloads are unchanged). Pass/receive plain yyyy-mm-dd strings. */

const toDate = (s) => {
  if (!s) return null;
  const [y, m, d] = String(s).slice(0, 10).split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
};

const toStr = (d) => {
  if (!d) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export default function DateField({
  value,
  onChange,
  id,
  name,
  required,
  disabled,
  maxDate,
  minDate,
  placeholder = "dd-mm-yyyy",
  className = "form-control",
}) {
  return (
    <DatePicker
      id={id}
      name={name}
      selected={toDate(value)}
      onChange={(d) => onChange(toStr(d))}
      dateFormat="dd-MM-yyyy"
      placeholderText={placeholder}
      className={className}
      wrapperClassName="d-block"
      required={required}
      disabled={disabled}
      maxDate={maxDate}
      minDate={minDate}
      showPopperArrow={false}
      autoComplete="off"
      popperProps={{ strategy: "fixed" }}
    />
  );
}
